import React from "react";
import styled from "styled-components";
import { FiArrowUp } from "react-icons/fi";
import { useScrolledPast } from "../../../hooks";
import { useLanguage } from "../../../contexts";
import { colors, easing, shadows } from "../../../theme";
import { scrollBehavior } from "../../../utils";

const Button = styled.button`
  position: fixed;
  right: max(1.25rem, env(safe-area-inset-right));
  bottom: calc(1.25rem + env(safe-area-inset-bottom));
  z-index: 90;
  display: grid;
  place-items: center;
  width: 3rem;
  height: 3rem;
  border: none;
  border-radius: 50%;
  background-color: ${colors.primary};
  color: ${colors.secondary};
  font-size: 1.25rem;
  box-shadow: ${shadows.honey};
  cursor: pointer;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? "visible" : "hidden")};
  transform: ${({ $visible }) =>
    $visible ? "none" : "translateY(1rem) scale(0.85)"};
  transition: opacity 0.4s ease, transform 0.4s ${easing.out},
    background-color 0.3s ease, visibility 0.4s;

  &:hover {
    background-color: ${colors.buttonHover};
    transform: translateY(-3px);
  }
`;

const BackToTop = () => {
  const isVisible = useScrolledPast(600);
  const { t } = useLanguage();

  return (
    <Button
      type="button"
      $visible={isVisible}
      tabIndex={isVisible ? 0 : -1}
      aria-label={t("NAVIGATION.BACK_TO_TOP")}
      onClick={() => window.scrollTo({ top: 0, behavior: scrollBehavior() })}
    >
      <FiArrowUp />
    </Button>
  );
};

export default BackToTop;
